import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { HotelService } from '../hotel/hotel.service'
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    
  public errormessage:String;
  public hotel$;            // Observables get a $
  private isLoggedEndRef: Subscription = null;

  constructor(private hotelService:HotelService, private loginService: LoginService) { }

  ngOnInit() {
      this.isLoggedEndRef=this.loginService.isLogged$.subscribe((_isLogged)=>{
          console.log( 'isLogged$ sent received: ' + _isLogged )
          if (_isLogged) {
            var that=this;
//          this.hotelService.getHotel()
//              .subscribe(( data ) => {
//                  if ( data != null && data.error == null ) {
//                      that.hotel = data.hotel                   // Keep hotel locally
//                      that.loginService.hotel = data.hotel      // Share w/ everyone
//                      console.log( 'returned hotel json: ' + JSON.stringify( this.hotel, null, 2 ) );
//                  } else {  // Book not found, get error message
//                      that.errormessage = "Erreur au chargement des données";
//                      console.log( 'Erreur au chargement des données' )
//                      // this.router.navigate(['/errorpage']);
//                  }
//              });
          that.hotel$=this.hotelService.getHotel()
      }
      })

  }
  
  ngOnDestroy(){
      this.isLoggedEndRef.unsubscribe()
  }  
}
